import * as types from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  error: null,
};

const DeleteSpeakerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DELETE_SPEAKERS_REQUEST:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DELETE_SPEAKERS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.DELETE_SPEAKERS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default DeleteSpeakerReducer;
